<mat-dialog-content class="dialog-content">
  <section>
    <mds-grid
      [minHeight]="'100%'"
      [overrides]="overrides"
      [sizeColumnsToFit]="true"
      [themeClass]="'ag-theme-material'"
      (gridReady)="onGridReady($event)">
    </mds-grid>
  </section>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <mds-button
    (click)="createLegalEntity()"
    aria-label="Create" role="button" type="primary">Add New Legal Entity
  </mds-button>
</mat-dialog-actions>
